export enum GENDER_ENUM{
    MALE = "male",
    FEMALE = "female"
}
export enum CURRENCY_ENUM {
    NGN = "NGN",
    USD = "USD",
    GHS = "GHS",
    ZAR = "ZAR",
}

export enum TRANSACTION_TYPE_ENUM {
    AIRTIME = "airtime",
    DATA_TOP_UP = "data_topup",
    CABLE_SUBSCRIPTION = "cable_subscription",
    ELECTRICITY = "electricity",
    WALLET_TOPUP = "wallet_top_up",
    TRANSFER = "transfer",
    VOUCHER_PURCHASE = "voucher_purchase",
    VOUCHER_REDEMPTION = "voucher_redeem"
}

export enum PAYMENT_TYPE_ENUM {
    CARD = "card",
    VIRTUAL = "virtual",
    BANK_TRANSFER = "bank_transfer",
    WALLET = "wallet",
    USSD = "ussd",
    MOBILE_MONEY = "mobile_money",
    CRYPTO = "crypto",
    CASH = "cash",
}
export enum PAYMENT_STATUS {
    SUCCESS = "successful",
    FAILED = "failed",
    PENDING = "pending",
    INITIATED = "initiated",
    REFUNDED = "refunded",
    UNVERIFIED = "unverified"
}

export enum PAYMENT_SERVICE_ENUM {
    MONNIFY = "monnify",
    PAYSTACK = "paystack",
    SAFEHAVEN = "safe haven",
    FLUTTERWAVE = "flutter wave",
    RHOMBU = "rhombu",
}

export enum ACCOUNT_STATUS_ENUM {
    ACTIVE = "active",
    INACTIVE = "inactive",
    SUSPENDED = "suspended",
    LOCKED = "locked",
}

export enum KYC_STATUS_ENUM {
    APPROVED = "approved",
    REJECTED = "rejected",
    UNDER_REVIEW = "under_review",
}

export enum OtpPurposeEnum {
    REGISTER = "register",
    TWO_FACTOR_AUTH = "two_factor_authentication",
    RESET_PASSWORD = "reset_password",
    RESTORE_ACCOUNT = "restore_account",
}

export enum KYC_VERIFICATION_TYPE_ENUM {
    BVN = "BVN",
    NIN = "NIN",
}

export enum ACCOUNT_TYPE {
    INDIVIDUAL = "individual",
    BUSINESS = "business",
}

export enum TELECOM_NETWORK_TYPE_ENUM {
    MTN = "mtn",
    AIRTEL = "airtel",
    NINE_MOBILE = "9mobile",
    GLO = "glo",
}
export enum TV_CABLE_TYPE_ENUM {
    DSTV = "dstv",
    GOTV = "gotv",
    SHOWMAX = "showmax",
    STARTIME = "startime",
    SMILE = "smile",
}
export enum DATA_PLAN_CATEGORIZATION {
    HOURLY = "Hourly",
    DAILY = "Daily",
    WEEKLY = "Weekly",
    MONTHLY = "Monthly",
    AlwaysOn  = "Always On",
    BROADBAND  = "Broadband",
    CORPORATE  = "Corporate",
    SME  = "SME",
    SOCIAL  = "SOCIAL",
    MSME  = "SOCIAL",
}
export enum VirtualAccountTypeEnum {
    permanent="permanent",
    temporary="temporary"
}
export enum ReversalReason {
    USER_REQUEST = 'user_request',
    MERCHANT_REJECTION = 'merchant_rejection',
    BANK_CHARGEBACK = 'bank_chargeback',
    SYSTEM_ERROR = 'system_error',
    DUPLICATE_PAYMENT = 'duplicate_payment'
}
export enum ReversalStatus {
    PENDING = 'pending',
    COMPLETED = 'completed',
    FAILED = 'failed'
}
export enum TokenPurposeFlagEnum {
    "ACCESS",
    "OTP_VERIFICATION",
}
export enum BENEFICIARY_TYPE_ENUM {
    AIRTIME = "airtime",
    DATA = "data",
    TRANSFER = "transfer",
    ELECTRICITY = "electricity",
}

export enum VoucherType {
    SINGLE_USE = "SINGLE_USE", // Can be used once globally
    MULTI_USE = "MULTI_USE", // Can be used multiple times
}
